import React from "react";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";

const FCASupervision2009ToToday = () => {
  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title>FCA Supervision of MSBs Since 2009 | MSB Association</title>
        <meta
          name="description"
          content="On 20th August, Mr. James Borley, Director for Payment Services at Complyport, explored how FSA/FCA supervision of Money Service Businesses has evolved since 2009."
        />
        {/* Open Graph Meta Tags */}
        <meta
          property="og:title"
          content="FCA Supervision of MSBs Since 2009 | MSB Association"
        />
        <meta
          property="og:description"
          content="On 20th August, Mr. James Borley, Director for Payment Services at Complyport, explored how FSA/FCA supervision of Money Service Businesses has evolved since 2009."
        />
        <meta property="og:type" content="website" />
        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
        ================================================== */}
        <section
          id="overview"
          className="page_header text-center section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
            <h1 className="page_title text-white">
              FCA Supervision of MSBs Since 2009 - Webinar Highlights
            </h1>
          </div>
        </section>
        {/* Page Header - End
        ================================================== */}
        {/* Contact Section - Start
        ================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="item_details_content p-3">
              <div className="d-flex justify-content-end mb-3">
                <NavLink to="/webinars" className="btn bg-primary text-dark">
                  ← Back
                </NavLink>
              </div>
              <img
                className="rounded-2 mb-5"
                src="assets/images/webinars/fca-supervision-2009-to-today-recap.jpg"
                alt="FCA supervision of Money Service Businesses since 2009 with Mr. James Borley"
              />
              <p className="mb-5">
                On 20th August, attendees from across the MSB industry joined
                an insightful session led by{" "}
                <strong>Mr. James Borley, Director for Payment Services at Complyport</strong>,
                exploring how FSA/FCA supervision of Money Service Businesses
                has evolved since 2009. James shared valuable insights into the
                shift from light-touch supervision to more active regulatory
                intervention, what supervisors are looking for from MSBs today,
                and the key areas the FCA expects remittance firms to focus on.
                He also discussed the changing regulatory landscape, the future
                of payment services regulation, and what upcoming developments
                could mean for the MSB sector.
              </p>

              <div className="item_details_content p-3">
                <div className="row mb-5">
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/date.svg"
                        alt="Date"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Date</h5>
                        <span>Thursday 20 Aug, 2026</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/time.svg"
                        alt="Time"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Time</h5>
                        <span>2 PM (UK Time)</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/platform.svg"
                        alt="Platform"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Platform</h5>
                        <span>Online Webinar</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-3 col-12">
                    <div className="event-detail-bg mb-1">
                      <img
                        src="assets/images/event-banner/attendance.svg"
                        alt="Attendance"
                      />
                      <div className="text-white">
                        <h5 className="fw-bold mb-1 text-white">Attendance</h5>
                        <span>100+ Attendees</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4 mt-4 align-items-baseline">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                      Evolution of FCA Supervision
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul>
                          <li>
                            How FCA supervision of MSBs has changed since 2009
                          </li>
                          <li>
                            The shift from light-touch supervision to active
                            intervention
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                      Future Regulatory Developments
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul>
                          <li>
                            Proposed changes to the Payment Services Regulations
                          </li>
                          <li>
                            What future regulatory changes could mean for MSBs
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row mb-4 mt-4 align-items-center">
                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="schedule-date fw-bold fs-5">
                      What Made It Stand Out
                    </div>
                    <div className="schedule-card">
                      <div className="schedule-item mb-2">
                        <ul>
                          <li>
                            Insights from <strong>James Borley&apos;s</strong>{" "}
                            experience as a former FCA supervisor.
                          </li>
                          <li>
                            Practical understanding of how FCA supervision has
                            evolved.
                          </li>
                          <li>
                            Real-world perspective on regulatory expectations.
                          </li>
                          <li>
                            Insights into what the future may hold for the MSB
                            sector.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <hr className="d-block d-sm-none" />

                  <div className="col-lg-6 col-md-6 col-12">
                    <div className="video-responsive-wrapper">
                      <iframe
                        src="https://www.youtube.com/embed/0gEWOR7czDA"
                        title="Evolution of FCA Supervision of MSBs Since 2009 - Expert Session by Mr. James Borley"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerpolicy="strict-origin-when-cross-origin"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default FCASupervision2009ToToday;
